<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品设置信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="addDialogVisible = true"
            >新增</el-button
          >
          <el-button
            icon="el-icon-download"
            plain
            @click="getpdfyes"
            class="download"
            type="warning"
            size="mini"
          >导出</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 商品信息表格 -->
        <el-table id="pdfDom" :data="productSetingList">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="产品编号" prop="ProductNO" align="center"></el-table-column>
          <el-table-column
            label="产品名称"
            prop="ProductName"
             align="center"
          ></el-table-column>
          <el-table-column
            label="产品编码"
            prop="ProductCode"
             align="center"
          ></el-table-column>
          <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
          <el-table-column label="规格型号" prop="Spec" align="center"></el-table-column>
          <el-table-column
            label="单位"
            prop="Unit"
            width="100px"
             align="center"
          ></el-table-column>
          <el-table-column
            label="是否使用"
            prop="Is_Use"
            width="100px"
             align="center"
          ></el-table-column>
          <el-table-column label="备注" prop="Remark" align="center"></el-table-column>
          <el-table-column
            label="创建时间"
            prop="CreateTimeConvert"
            width="150px"
             align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220px" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                size="mini"
                @click="showEditDialog(scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                @click="removeproductSeting(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 添加产品设置信息的对话框 -->
    <el-dialog
      title="添加产品"
      :visible.sync="addDialogVisible"
      width="30%"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="130px"
      >
        <el-form-item label="产品编号" prop="ProductNO">
          <el-input
            v-model="addForm.ProductNO"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品编号" prop="TypeName">
          <el-select v-model="addForm.TypeName" placeholder="请选择产品类型">
            <el-option v-for="item in goodslist" :key="item.ID" :label="item.TypeName" :value="item.TypeName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="产品名称" prop="ProductName" required>
          <el-input
            v-model="addForm.ProductName"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品类型" prop="ProductType_Name">
          <el-input
            v-model="addForm.ProductType_Name"
            style="width: 90%"
            size="medium"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="规格型号" prop="Spec">
          <el-input
            v-model="addForm.Spec"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input
            v-model="addForm.Unit"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="Is_Use" required>
          <!-- <el-input v-model="addForm.Is_Use" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model="addForm.Remark"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProductSeting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑产品信息的会话框 -->
    <el-dialog
      title="修改产品信息"
      :visible.sync="editDialogVisible"
      width="35%"
      @close="editDialogClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editFormRef"
        label-width="110px"
      >
        <el-form-item label="产品编号" prop="ProductNO">
          <el-input v-model="editForm.ProductNO"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="ProductName" required>
          <el-input v-model="editForm.ProductName"></el-input>
        </el-form-item>
        <el-form-item label="产品类型" prop="ProductType_ID">
          <el-input
            v-model="addForm.ProductType_Name"
            style="width: 90%"
            size="medium"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="规格型号" prop="Spec">
          <el-input v-model="editForm.Spec"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input v-model="editForm.Unit"></el-input>
        </el-form-item>
        <!-- <el-form-item label="库存单位上限" prop="Stock_Up">
          <el-input v-model="editForm.Stock_Up"></el-input>
        </el-form-item>
        <el-form-item label="库存单位下限" prop="Stock_Down">
          <el-input v-model="editForm.Stock_Down"></el-input>
        </el-form-item> -->
        <el-form-item label="是否启用" prop="Is_Use" required>
          <!-- <el-input v-model="addForm.Is_Use" style="width: 90%" size="medium"></el-input> -->
          <el-select v-model="editForm.Is_Use" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设置物料的会话框 -->
    <!-- <el-dialog title="设置物料" :visible.sync="setingDialogVisible" width="80%" @close="setingDialogClose">
      <el-table :data="ProducIDMaterialList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="产品类型" prop="TypeName"></el-table-column>
        <el-table-column label="创建人" prop="CreateUser" width="150px"></el-table-column>
        <el-table-column label="是否使用" prop="Is_Use" width="120px"></el-table-column>
        <el-table-column label="备注" prop="Remark" width="250px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: "1",
        limit: "5",
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
        tableName: " Main_ProductSet",
      },
      getTypeList1: {
        page: "1",
        limit: "100",
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      total: 0,
      // 产品设置信息表
      productSetingList: [],
      // 控制新增对话框的开启与关闭
      addDialogVisible: false,
      // 添加产品设置信息的表单数据
      addForm: {
        ProductNO: "",
        ProductName: "",
        ProductCode: "",
        CreateTime: "",
        ProductType_ID: "1",
        ProductType_Name: "成品",
        Spec: "",
        Unit: "",
        Stock_Up: "",
        Stock_Down: "",
        Is_Use: "",
        Remark: "",
      },
      //添加表单的验证规则对象
      addFormRules: {},
      // 控制修改对话框的开启与关闭
      editDialogVisible: false,
      // 修改信息的表单数据
      editForm: {},
      // 修改表单的验证规则对象
      editFormRules: {},
      // 控制设置物料对话框的显示与隐藏
      setingDialogVisible: false,
      // 产品关联物料表
      ProducIDMaterialList: [],
      // 是否启用
      options: [
        {
          value: "Y",
          label: "是",
        },
        {
          value: "N",
          label: "否",
        },
      ],
      // 产品类型表
      productTypeList: [],
    };
  },
  created() {
    this.getproductSetingList();
    this.getproductSetingList1();
    this.getProductType();
  },
  methods: {
    // 调用接口获取产品设置信息
    async getproductSetingList() {
      const { data: res1 } = await this.$http.get("/WMS/queryProductType", {
        params: this.getTypeList,
      });
      console.log(res1.data);
      const { data: res } = await this.$http.get("/WMS/queryProductSet", {
        params: this.getTypeList,
      });
      console.log(res.data);
      //     if (res.data.ProductType_ID == res1.data.ID) {
      //         res.data.ProductType_ID = res1.data.TypeName
      // }

      this.productSetingList = res.data;
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].Is_Use == "Y") {
          res.data[i].Is_Use = "是";
        }
        if (res.data[i].Is_Use == "N") {
          res.data[i].Is_Use = "否";
        }
      }
    },
    // 调用接口获取产品设置信息
    async getproductSetingList1() {
      const { data: res } = await this.$http.get("/WMS/queryProductSet", {
        params: this.getTypeList1,
      });
      console.log(res.data);
      this.total = res.data.length;
    },
    // 调用接口删除产品设置信息
    async removeproductSeting(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该产品, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }

      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.post(
        "/WMS/deleteProductSet",
        params
      );
      console.log(res);
      if (res == -3) {
        return this.$message.error("删除失败,此产品已关联物料！");
      }
      if (res !== 1) {
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getproductSetingList();
      this.getproductSetingList1();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    //  监听设置物料对话框的关闭事件
    setingDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 调用接口新增产品设置信息
    addProductSeting() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("ProductNO", this.addForm.ProductNO);
        params.append("ProductName", this.addForm.ProductName);
        params.append("Is_Use", this.addForm.Is_Use);
        params.append("ProductType_ID", this.addForm.ProductType_ID);
        params.append("Spec", this.addForm.Spec);
        params.append("Unit", this.addForm.Unit);
        params.append("Remark", this.addForm.Remark);
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/InsertProductSet",
          params
        );
        console.log(res);
        if (res !== 1) {
          return this.$message.error("系统异常，添加失败！");
        }
        this.$message.success("添加产品类型成功！");
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getproductSetingList();
        this.getproductSetingList1();
      });
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    // 展示修改产品的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("tableName", this.getTypeList.tableName);
      console.log("1125" + scope.row.ID);
      const { data: res } = await this.$http.get("/WMS/queryProductSetID", {
        params,
      });
      console.log(res.data);
      this.editForm = res.data[0];
    },
    // 调用接口编辑产品2
    editProduct() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        // params.append("ProductCode", this.editForm.ProductCode)
        params.append("ProductNO", this.editForm.ProductNO);
        params.append("ProductName", this.editForm.ProductName);
        params.append("ProductType_ID", this.addForm.ProductType_ID);
        params.append("ID", this.editForm.ID);
        params.append("CreateTime", this.editForm.CreateTime);
        params.append("Is_Use", this.editForm.Is_Use);
        params.append("Remark", this.editForm.Remark);
        params.append("Spec", this.editForm.Spec);
        params.append("Stock_Down", this.editForm.Stock_Down);
        params.append("Stock_Up", this.editForm.Stock_Up);
        params.append("Unit", this.editForm.Unit);
        const { data: res } = await this.$http.post(
          "/WMS/updateProductSet",
          params
        );
        console.log(res);
        if (res !== 1) {
          this.$message.error("更新产品类型信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getproductSetingList();
        this.getproductSetingList1();
        // 提示修改成功
        this.$message.success("更新产品类型信息成功！");
      });
    },

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log("111" + newSize);
      this.getTypeList.limit = newSize;
      this.getproductSetingList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.getTypeList.page = newPage;
      this.getproductSetingList();
    },
    getpdfyes() {
      this.getPdf();
    },
    // 调用接口获取产品类型
    async getProductType() {
      const { data: res } = await this.$http.get("/WMS/queryProductType", {
        params: this.getTypeList,
      });
      console.log(res.data);
      this.productTypeList = res.data;
    },
  },
};
</script>

<style lang="less" scoped>
</style>

